import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { isRightToLeft } from '../../utils/helpers/locale.helper';

export default function HelmetConfig() {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? i18n.language;
  const direction = isRightToLeft() ? 'rtl' : 'ltr';

  return (
    <Helmet>
      <html lang={language} dir={direction} />
    </Helmet>
  );
}
